import React from 'react';
import { LabelInput, TextInput, Button } from 'modules/v2/common/AtomicDesign/atoms';
import { Tooltip } from 'flowbite-react';
import { QuestionCircleIcon } from 'modules/v2/common/components/SvgIcon';

import { TemplateFilePicker } from 'modules/v2/pages/TemplatesBuilder/shared-components/TemplateFilePicker';
import { formatPhoneNumber, FormData } from 'modules/v2/pages/TemplatesBuilder/utils/setupModalUtils';

interface Step1Props {
  formData: FormData;
  onFormDataChange: (data: any) => void;
}

export const isStep1Valid = (formData: FormData) => {
  return formData.fullName && formData.email && formData.phone && formData.headshot;
};

export const Step1: React.FC<Step1Props> = ({ formData, onFormDataChange }) => {
  const handleFileUpload = (file: File) => {
    onFormDataChange({ ...formData, headshot: file });
  };

  const handleInputChange = (field: string, value: string) => {
    if (field.toLowerCase().includes('phone'))
      onFormDataChange({ ...formData, [field]: formatPhoneNumber(value) });
    else
      onFormDataChange({ ...formData, [field]: value });
  };

  // const isValid = formData.fullName && formData.email && formData.phone && formData.headshot;

  return (
    // <div className="px-6">
    //   <div className="mb-6">
    //     <p className="text-neutral-800 text-sm leading-5 font-semibold text-center">
    //       We'll use this info to pre-fill your templates so you can save time and look
    //       professional—every time. You'll still be able to change anything later if you want.
    //     </p>
    //   </div>

    <div className="space-y-4">
      <TemplateFilePicker
        label="Your Professional Headshot"
        name="headshot-upload"
        tooltip="Upload a photo of yourself that will show on your marketing materials."
        onChange={handleFileUpload}
        value={formData.headshot}
        required
      />

      <div>
        <div className="flex">
          <LabelInput className="mr-1.5" required>
            Your Full Name
          </LabelInput>
          <Tooltip theme={{ style: { dark: 'bg-[#252525] text-white' }, }} content="This is how your name will appear on all templates.">
            <QuestionCircleIcon />
          </Tooltip>
        </div>
        <TextInput
          type="text"
          value={formData.fullName}
          onChange={(e) => handleInputChange('fullName', e.target.value)}
          placeholder="Enter your full name"
        />
      </div>

      <div>
        <div className="flex">
          <LabelInput className="mr-1.5" required>
            Your Email Address
          </LabelInput>
          <Tooltip theme={{ style: { dark: 'bg-[#252525] text-white' }, }} content="We'll use this anywhere your contact info is shown.">
            <QuestionCircleIcon />
          </Tooltip>
        </div>
        <TextInput
          type="email"
          value={formData.email}
          onChange={(e) => handleInputChange('email', e.target.value)}
          placeholder="Enter your email address"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <div className="flex">
            <LabelInput className="mr-1.5" required>
              Your Best Phone Number
            </LabelInput>
            <Tooltip theme={{ style: { dark: 'bg-[#252525] text-white' }, }} content="Use the number you want clients to call or text.">
              <QuestionCircleIcon />
            </Tooltip>
          </div>
          <TextInput
            type="tel"
            value={formData.phone}
            onChange={(e) => handleInputChange('phone', e.target.value)}
            placeholder="Enter your phone number"
          />
        </div>
        <div>
          <div className="flex">
            <LabelInput className="mr-1.5" required={false}>
              Alternate Phone Number (Optional)
            </LabelInput>
            <Tooltip theme={{ style: { dark: 'bg-[#252525] text-white' }, }} content="If you have a separate number for marketing, you can add it here.">
              <QuestionCircleIcon />
            </Tooltip>
          </div>
          <TextInput
            type="tel"
            value={formData.alternatePhone}
            onChange={(e) => handleInputChange('alternatePhone', e.target.value)}
            placeholder="Enter alternate phone (optional)"
          />
        </div>
      </div>
    </div>
  );
};

